import { createRouter, createWebHistory } from 'vue-router'
import CatalogView from '../components/CatalogView.vue'
import TicketList from '../components/TicketList.vue'
import QRCode from '../components/QRCode.vue'

const routes = [
  {
    path: '/',
    redirect: (to) => {
      const retailId = to.query.retailId || '801000'
      return { name: 'TicketList', params: { retailId } }
    },
  },
  { name: 'TicketList', path: '/ticket-list/:retailId', component: CatalogView },
  { name: 'TicketListLegacy', path: '/ticket-list-legacy/:retailId', component: TicketList },
  { name: 'QRCode', path: '/qrcode/:retailId', component: QRCode },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

export default router
